
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/reward/check-in",
      function () {
        return require("private-next-pages/user/reward/check-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/reward/check-in"])
      });
    }
  